import { render, staticRenderFns } from "./SendWebNotificationConfig.vue?vue&type=template&id=f5ed6a1a&scoped=true"
import script from "./SendWebNotificationConfig.vue?vue&type=script&lang=js"
export * from "./SendWebNotificationConfig.vue?vue&type=script&lang=js"
import style0 from "./SendWebNotificationConfig.vue?vue&type=style&index=0&id=f5ed6a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ed6a1a",
  null
  
)

export default component.exports